export default () => (
	<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			xmlns="http://www.w3.org/2000/svg"
			d="M23.9 8.4H21.7V18.3H7.4V20.5C7.4 21.105 7.895 21.6 8.5 21.6H20.6L25 26V9.5C25 8.895 24.505 8.4 23.9 8.4ZM19.5 15V5.1C19.5 4.495 19.005 4 18.4 4H4.1C3.495 4 3 4.495 3 5.1V20.5L7.4 16.1H18.4C19.005 16.1 19.5 15.605 19.5 15Z"
			fill="#367BF5"
		/>
	</svg>
);
